//auth
export const AUTH_ERROR = "AUTH_ERROR";
export const CONFIRM_EXIT = "CONFIRM_EXIT";
//articles
export const CONFIRM_DELETE_ARTICLE = "CONFIRM_DELETE_ARTICLE";
//pagination
export const ERROR_SET_PAGE = "ERROR_SET_PAGE";



// WEBPACK FOOTER //
// ./src/constants/modalTypes.js